module.exports = __webpack_public_path__ + "img/autochess.f32701a3.jpg";